import {Component, Input, OnInit} from '@angular/core';
import {DashboardService} from "app/archivage/common/services/dashboard/dashboard.service";
import {Dashboard} from "app/archivage/common/services/dashboard/dashboard.model";
import {MatDialog} from "@angular/material/dialog";
import {MagDetailComponent} from "app/archivage/dashboard/mag-detail/mag-detail.component";


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  @Input() expanded: boolean;

  dashboard: Dashboard;

  constructor(
    public dashboardSvc: DashboardService,
    private dialog: MatDialog,) {
  }

  ngOnInit(): void {
    this.dashboardSvc.listAllItems().subscribe(
      res => this.dashboard = <any>res.list
    );
  }

  magDetail() {
    const magDetailModale = this.dialog.open(MagDetailComponent, {data: this.dashboard.mls.detail_mag});
    magDetailModale.updateSize('600px');
    magDetailModale.updatePosition({top: '150px'});
    magDetailModale.afterClosed().subscribe();
  }
}
